import React, { useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedServiceRequests, deleteServiceRequest } from '../../../services/serviceRequestService';
import { ServiceRequest } from '../../../types/serviceRequest';
import { getServiceRequestColumns } from './ServiceRequestColumns';
import Table from '../../../components/common/Table';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import pageStyles from '../../Page.module.css';
//import sharedStyles from '../../SharedPageStyles.module.css';

import Icon from '../../../components/common/Icon';

interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};
const ServiceRequestsListPage: React.FC = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [requestToDelete, setRequestToDelete] = useState<ServiceRequest | null>(null);

  const openDeleteDialog = (request: ServiceRequest) => {
    setRequestToDelete(request);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setRequestToDelete(null);
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    if (!requestToDelete) return;
    const promise = deleteServiceRequest(requestToDelete.id);
    toast.promise(promise, {
      loading: 'جاري حذف الطلب...',
      success: () => {
        closeDeleteDialog();
        refreshData();
        return 'تم حذف الطلب بنجاح!';
      },
      error: (err) => {
        closeDeleteDialog();
        return err.response?.data?.message || 'فشل في حذف الطلب.';
      },
    });
  };

  const columns = useMemo(() => getServiceRequestColumns(openDeleteDialog), []);

  const { table, isLoading, Pagination, refreshData, searchTerm, setSearchTerm } = useServerSideTable<ServiceRequest>({
    columns,
    fetchData: getPagedServiceRequests,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>إدارة طلبات الخدمات</h1>
        <Link to="/admin/service-requests/new" className={pageStyles.addButton}>
          <Icon as={FaPlus} style={pageStyles.icon } />
          <span>إضافة طلب</span>
        </Link>
      </div>
      <div className={pageStyles.pageContent}>
        <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <Table<ServiceRequest> table={table} isLoading={isLoading} />
        <Pagination />
      </div>
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من رغبتك في حذف الطلب رقم "${requestToDelete?.id}"؟`}
        onConfirm={handleDelete}
        onCancel={closeDeleteDialog}
      />
    </div>
  );
};

export default ServiceRequestsListPage;
